import { SERVER_URL } from '../../constants.js';
import { formatLocalDateOnly } from './dateFormatters';

export const addTransfer = async (transfer, studentId) => {
  const formattedTransfer = {
    ...transfer,
    transferDate: formatLocalDateOnly(transfer.transferDate),
  };

  const token = sessionStorage.getItem('bearer');
  const res = await fetch(`${SERVER_URL}api/transfers/${studentId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(formattedTransfer)
  });

  if (!res.ok) {
    throw new Error('Failed to add transfer');
  }
};

export const editTransfer = async (transfer, transferId) => {
  const formattedTransfer = {
    ...transfer,
    transferDate: formatLocalDateOnly(transfer.transferDate),
  };

  const token = sessionStorage.getItem('bearer');
  const res = await fetch(`${SERVER_URL}api/transferid/${transferId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(formattedTransfer)
  });

  if (!res.ok) {
    throw new Error('Failed to update transfer');
  }
};

export const deleteTransfer = async (transferId) => {
  const token = sessionStorage.getItem('bearer');
  const res = await fetch(`${SERVER_URL}api/transferid/${transferId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    throw new Error('Failed to delete transfer');
  }
};
